/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentForListing } from './DocumentForListing';
import {
    DocumentForListingFromJSON,
    DocumentForListingFromJSONTyped,
    DocumentForListingToJSON,
} from './DocumentForListing';

/**
 * 
 * @export
 * @interface DocumentListResponse
 */
export interface DocumentListResponse {
    /**
     * 
     * @type {Array<DocumentForListing>}
     * @memberof DocumentListResponse
     */
    documents: Array<DocumentForListing>;
}

/**
 * Check if a given object implements the DocumentListResponse interface.
 */
export function instanceOfDocumentListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documents" in value;

    return isInstance;
}

export function DocumentListResponseFromJSON(json: any): DocumentListResponse {
    return DocumentListResponseFromJSONTyped(json, false);
}

export function DocumentListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documents': ((json['documents'] as Array<any>).map(DocumentForListingFromJSON)),
    };
}

export function DocumentListResponseToJSON(value?: DocumentListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documents': ((value.documents as Array<any>).map(DocumentForListingToJSON)),
    };
}

